import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsAndConditions.css';

/**
 * TermsAndConditions component
 * Modern, animated design matching the CookiePolicy style
 */
const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <div className="terms-policy-container">
      {/* Floating decorative elements */}
      <div className="terms-floating-element terms-floating-element-1" />
      <div className="terms-floating-element terms-floating-element-2" />
      <div className="terms-floating-element terms-floating-element-3" />
      
      <div className="terms-content-wrapper">
        {/* Header moderne */}
        <div className="terms-policy-header">
          <div className="terms-icon-container">
            <span className="terms-icon">📜</span>
          </div>
          
          <h1 className="terms-title">
            {t('terms.title', 'Conditions Générales')}
          </h1>
          
          <p className="terms-subtitle">
            {t('terms.subtitle', 'Terms & Conditions / Conditions Générales d\'Utilisation')}
          </p>
        </div>

        {/* Contenu principal avec iframe */}
        <div className="terms-policy-section">
          {/* Barre décorative animée */}
          <div className="terms-decorative-bar" />
          
          {/* Effet de brillance */}
          <div className="terms-shine-effect" />
          
          <div className="terms-content-padding">
            {/* Date de mise à jour */}
            <div className="terms-update-badge">
              <div className="terms-update-badge-bar" />
              <p className="terms-update-text">
                <span className="terms-pulse-dot" />
                {t('terms.lastUpdated', 'Dernière mise à jour : 7 novembre 2025')}
              </p>
            </div>

            {/* iFrame avec le contenu bilingue */}
            <div className="terms-iframe-container">
              <iframe
                title="Terms and Conditions"
                src="/terms-and-conditions.html"
                className="terms-iframe"
                sandbox="allow-same-origin allow-popups allow-top-navigation-by-user-activation"
              />
            </div>

            {/* Bouton retour */}
            <div className="terms-back-button-container">
              <a href="/" className="terms-back-button">
                ← {t('terms.backHome', 'Retour à l\'accueil')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
